import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Button } from './Button';
import { Seal } from '../brand/Seal';
import { useBrand } from '../../contexts/BrandContext';
interface CtaBandProps {
  title?: string;
  intro?: string;
}
export function CtaBand({
  title,
  intro
}: CtaBandProps) {
  const {
    brand,
    text
  } = useBrand();
  const heading = title ? text(title) : brand.copy.manifesto;
  const body = intro ? text(intro) : brand.copy.ctaIntro;
  return <section className="border-t border-ink/10 bg-cream-deep text-ink" data-id="element-254" data-mp="v0foh524eh74">
      <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-24" data-id="element-255" data-mp="qzm24g4btagc">
        <div className="grid items-center gap-12 lg:grid-cols-[1.3fr_auto] lg:gap-20" data-id="element-256" data-mp="m1atu9toj808">
          <div data-id="element-257" data-mp="h3iy14pwz1qr">
            <h2 className="max-w-2xl font-serif text-4xl leading-[1.06] md:text-[3.5rem]" data-id="element-258" data-mp="h4140t2doubv">
              {heading}
            </h2>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-ink-soft" data-id="element-259" data-mp="2gfbxr9436l76">{body}</p>
            <div className="mt-10 flex flex-wrap items-center gap-4" data-id="element-260" data-mp="2bhtp7jtze7zp">
              <Button to="/get-started" data-id="element-261" data-mp="2p50lmiwbxbws">
                Start your intake
                <ArrowRightIcon className="h-4 w-4" data-id="element-262" data-mp="2t7f2ixgfu1lf" />
              </Button>
              <Button to="/pricing" variant="secondary" data-id="element-263" data-mp="2t5c7fz0fhi9u">
                See pricing
              </Button>
            </div>
          </div>
          <Seal className="hidden h-40 w-40 text-brick/60 lg:block" data-id="element-264" data-mp="2k67a2w0lruz9" />
        </div>
      </div>
    </section>;
}